import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { ProductBuilderState } from '../state'
import Alert from '@material-ui/lab/Alert'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/styles'
import { ProductCost } from '../../product/model'
import classnames from 'classnames'
import { priceToString } from '../../../core'

const useStyles = makeStyles((theme: any) => ({
    root: {
        '& .ProductBuilderSummaryTitle': {
            marginTop: theme.spacing(3)
        },
        '& .row': {
            '& .space': {
                borderBottom: 'dotted 1px black',
                flexGrow: 1,
                margin: '0 2px 4px 2px'
            },
            '&.new': {
                marginTop: theme.spacing(3)
            },
            '&.total': {
                fontWeight: 'bold'
            }
        },
        '& .bottom': {
            paddingTop: theme.spacing(3)
        },
        '& .alert': {
            marginTop: theme.spacing(3)
        }
    }
}), { name: 'ProductBuilderSummary' })

interface RowProps extends ProductCost {
    currency: string
    newGroup: boolean
}

const Row = (props: RowProps) => {
    return <Grid item container className={classnames({ 'row': true, 'total': props.total, 'new': props.newGroup })}>
        <Grid item>{props.name}</Grid>
        <Grid item className='space'></Grid>
        <Grid item>{priceToString(props.amount, props.currency)}</Grid>
    </Grid>
}

const productBuilderSummaryView = (props: ProductBuilderState) => {
    const classes = useStyles(props)
    const [showAlert, setShowAlert] = useState(false)

    const isEveryParameterAndCostsSet = () => {
        const productCostItems = props.productCost.map(item => item.group).filter(item => item === 'parameters' || item === 'other' ).length
        const productConfigurationItems = Object.entries(props.product.configuration).length - 1
        const productAllPrices = props.productCost.map(item => item.amount).filter(item => isNaN(item) ).length
        const laterParameter = props.product.configuration.design.filter(item => item.key === 'later').length
        const isLaterParameter = productAllPrices > 0 && laterParameter > 0
        return productCostItems === productConfigurationItems && productAllPrices === 0  ? true : isLaterParameter ? true : false
    }

    const addToCartAction = () => {
        props.dispatch({ type: 'PRODUCT_BUILDER_ADD_TO_CART', params: { product: props.product, productParameters: props.productParameters }})
    }

    const callAlertOrAddToCartAction = () => {
        isEveryParameterAndCostsSet() ? addToCartAction() : setShowAlert(true)
    }

    useEffect(() => {
        isEveryParameterAndCostsSet() ? setShowAlert(false) : null
    }, [props.productCost])

    return <Grid container direction='column' className={classes.root}>
        <Grid item>
            <Typography variant='h5' className='ProductBuilderSummaryTitle'>Summary</Typography>
        </Grid>
        <Grid item container direction='column'>
            {props.productCost.filter(it => !it.summaryHidden).map((cost, index) =>
                <Row
                    key={index}
                    {...cost}
                    newGroup={index === 0 || props.productCost[index - 1].group !== cost.group}
                    currency={props.product.currency}
                />
            )}
        </Grid>
        <Grid item container direction='column' justify='center' alignItems='stretch' className='bottom'>
            <Button
                variant='contained'
                fullWidth
                color='primary'
                onClick={callAlertOrAddToCartAction}
                disabled={props.loading}>
                Add to cart
            </Button>
        </Grid>
        {showAlert && <Alert variant='filled' severity='error' className='alert'>
            Please choose all parameters before proceeding to cart.
        </Alert>}
    </Grid>
}

export const ProductBuilderSummaryView =
    connect((state: any) => state.productBuilderState)(productBuilderSummaryView)